export type SupportedLanguage = {
  code: string;
  name: string;
  flag: string;
};

export const supportedLanguages: SupportedLanguage[] = [
  { code: "en", name: "English", flag: "/uploads/flags/en.png" },
  { code: "zh-cn", name: "Chinese", flag: "/uploads/flags/zh-cn.png" },
  { code: "dk", name: "Danish", flag: "/uploads/flags/dk.png" },
  { code: "fr", name: "French", flag: "/uploads/flags/fr.png" },
  { code: "de", name: "German", flag: "/uploads/flags/de.png" },
  { code: "pt", name: "Portuguese", flag: "/uploads/flags/pt.png" },
  { code: "es", name: "Spanish", flag: "/uploads/flags/es.png" }
];
